import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import TodosItem from './TodosItem';
import DeleteConfirmation from '../ui/DeleteConfirmation';
import { sortOpts } from '../../utils/utils';

class TodosForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      todo_desc: '',
      todolist_desc: props.todolist.todolist_desc,
      todolist_dline: props.todolist.todolist_dline,
      todo_dline: props.todolist.todolist_dline,
      todo_user_id: props.userId || 0,
      errors: {},
      adding: false,
      delConf: false,
      editing: false
    };
  }

  editTodolist = () => {
    const { todolist_desc, todolist_dline } = this.state;
    if (!todolist_desc) return;
    this.props.editTodolist({
      ...this.props.todolist,
      todolist_desc,
      todolist_dline
    }, errors => {
      if (errors) {
        this.setState({errors});
        return;
      }
      this.setState({
        errors: {},
        editing: false
      });
    });
  }

  deleteTodolist = () => {
    this.props.editTodolist({
      ...this.props.todolist,
      todolist_active: 0
    }, errors => {
      if (errors) {
        this.setState({errors});
        return;
      }
    });
  }

  startEditing = () => {
    this.setState({editing: true});
  }

  cancelEditing = () => {
    this.setState({
      editing: false,
      errors: {}
    });
  }

  startAdding = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({adding: true});
  }

  cancelAdding = () => {
    this.setState({
      adding: false,
      errors: {}
    });
  }

  createTodo = e => {
    if (!this.state.todo_desc) return;

    this.props.editTodo({
      todo_desc: this.state.todo_desc,
      todo_todolist_id: this.props.todolist.todolist_id,
      todo_user_id: this.state.todo_user_id,
      todo_dline: this.state.todo_dline,
      todo_active: 1,
      todo_done: 0,
      orderId: this.props.todolist.todolist_order_id
    }, errors => {
      if (errors) {
        this.setState({errors});
        return;
      }
      this.setState({
        adding: false,
        todo_desc: '',
        todo_dline: this.props.todolist.todolist_dline,
        todo_user_id: this.props.userId || 0,
        errors: {}
      });
    });
  }

  updateInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  updateDate = e => {
    this.setState({
      todolist_dline: e.format('Y-MM-DD')
    });
  }

  updateTodoDate = e => {
    this.setState({
      todo_dline: e.format('Y-MM-DD')
    });
  }

  updateTodoUserId = e => {
    this.setState({
      todo_user_id: e.value
    });
  }

  toggleDelConf = () => {
    const delConf = !this.state.delConf;
    this.setState({delConf:delConf});
  }

  render() {
    const { todolist, todos, users } = this.props;
    const {
      todo_desc,
      errors,
      editing,
      adding,
      delConf,
      todolist_desc,
      todolist_dline,
      todo_dline,
      todo_user_id
    } = this.state;
    const todosActive = todos.filter(el => el.todo_active);
    const todosDone = todosActive.filter(el => el.todo_done);
    const allTodosDone = todosActive.length === todosDone.length;
    var usersOpt = [];
    for (let key in users){
      if(users.hasOwnProperty(key)) {
        if(users[key].user_active || users[key].user_id === todo_user_id){
          usersOpt.push({
            value: users[key].user_id,
            label: users[key].user_fname + " " + users[key].user_lname
          });
        }
      }
    }
    usersOpt.sort(sortOpts);
    return (
      <div className="todos-container">
        {delConf && (
          <DeleteConfirmation
            onDelete={this.deleteTodolist}
            onCancel={this.toggleDelConf}
          />
        )}
        <div className="row">
          <div className="col-sm-12">
            {editing ? (
              <div className="row margins">
                <div className="col-sm-3">
                  <input
                    type="text"
                    value={todolist_desc}
                    onChange={this.updateInput}
                    className="form-control"
                    name="todolist_desc"
                  />
                </div>
                {todolist.todolist_order_id !== 0 && (
                  <div className="col-sm-3">
                    <DatePicker
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      selected={moment(todolist_dline)}
                      onChange={this.updateDate}
                    />
                  </div>
                )}
                <div className="col-sm-6">
                  <button
                    onClick={this.editTodolist}
                    className="btn btn-success"
                    title="Сохранить"
                  >
                    <span className="glyphicon glyphicon-save"></span>
                  </button>{" "}
                  <button
                    onClick={this.toggleDelConf}
                    className="btn btn-danger"
                    title="Удалить"
                  >
                    <span className="glyphicon glyphicon-trash"></span>
                  </button>{" "}
                  <button
                    onClick={this.cancelEditing}
                    className="btn btn-default"
                    title="Отмена"
                  >
                    <span className="glyphicon glyphicon-remove"></span>
                  </button>
                </div>
              </div>
            ) : (
              <div className="show-hover-container">
                <button type="button" className="btn btn-info btn-xs show-hover"
                  onClick={this.startAdding}>
                  Добавить задачу
                </button>
                <h3
                  className={todolist.todolist_order_id !== 0 && !allTodosDone && "text-danger"}
                  onClick={this.startEditing}
                >
                  {todolist.todolist_desc} {todolist.todolist_order_id !== 0 && todosActive.length > 0 &&
                  <span>({todosDone.length}/{todosActive.length})</span>
                  } {todolist.todolist_order_id !== 0 &&
                    <span>- {moment(todolist.todolist_dline).format('L')}</span>
                  }
                </h3>
              </div>
            )}
          </div>
        </div>
        {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        {adding && (
          <div className="row margins">
            <div className="col-sm-6 form-horizontal">
              <label className="control-label col-sm-4">Добавить задачу</label>
              <div className="col-sm-8">
                <input
                  type="text"
                  value={todo_desc}
                  onChange={this.updateInput}
                  className="form-control"
                  name="todo_desc"
                />
              </div>
            </div>
            <div className="col-xs-1">
              {!!todo_user_id && (
                <DatePicker
                  className="form-control"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selected={moment(todo_dline)}
                  onChange={this.updateTodoDate}
                />
              )}
            </div>
            <div className="col-xs-2">
              {!!todo_user_id && (
                <Select
                  className="col-sm-12"
                  clearable={false}
                  options={usersOpt}
                  value={todo_user_id}
                  onChange={this.updateTodoUserId}
                />
              )}
            </div>
            <div className="col-sm-2">
              <button
                onClick={this.createTodo}
                className="btn btn-success"
                title="Добавить"
              >
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button
                onClick={this.cancelAdding}
                className="btn btn-default"
                title="Отмена"
              >
                <span className="glyphicon glyphicon-remove"></span>
              </button>
            </div>
          </div>
        )}
        <div className="todos-list">
          {todosActive.map(el => {
            return (
              <TodosItem
                key={el.todo_id}
                users={users}
                data={{
                  ...el,
                  orderId: todolist.todolist_order_id
                }}
                editTodo={this.props.editTodo}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default TodosForm;



// WEBPACK FOOTER //
// ./src/components/todo/TodosForm.js